var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHnS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8701 9.66003C18.8701 14.7134 14.7735 18.81 9.72007 18.81C4.66666 18.81 0.570068 14.7134 0.570068 9.66003L18.8701 9.66003Z",
    stroke: "#506C8E",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13016 7.72499C5.13016 7.72499 1.81516 8.08499 2.31016 4.49999C4.65016 4.16999 5.62516 5.69999 5.13016 7.72499Z",
    stroke: "#506C8E",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33496 3.32998C3.58101 3.441 2.82282 3.15755 2.32661 2.57915C1.83041 2.00075 1.66556 1.20827 1.88996 0.479978C3.91496 0.239978 4.76996 1.49998 4.33496 3.32998Z",
    stroke: "#506C8E",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.65 1.00499C10.65 1.00499 10.785 5.26499 6.14995 4.28999C5.99995 1.27499 8.08495 0.16499 10.65 1.00499Z",
    stroke: "#506C8E",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.665 9.55503L14.445 3.34503C15.54 1.44003 17.445 2.56503 16.71 4.29003L14.25 9.43503",
    stroke: "#506C8E",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnS);
export default __webpack_public_path__ + "static/media/HnS.f5662dc01d3e1f2a7abd8295f854e40e.svg";
export { ForwardRef as ReactComponent };